import React, { } from 'react';
import { Row, Col, message, Layout, Modal } from 'antd';
import TableWrapper from "../../elements/TableWrapper";
import img from '../../../assets/img/At the office-pana 1.png';
import MiCompAPI from '../../../util/api';
import moment from "moment";
import ManagePlan from './ManagePlan';
const { Content } = Layout;
const { confirm } = Modal;
class Enrollment extends React.Component {
  constructor(props) {
    super(props);
    this.columns = [{
      title: 'LOA',
      dataIndex: 'loa',
    },
    {
      title: 'Plan Id',
      dataIndex: 'plan_Id',
    },
    {
      title: 'Plan Name',
      dataIndex: 'plan_name',
    },
    {
      title: 'Client Name',
      dataIndex: 'client',
    },
    {
      title: 'Date of Enrollment',
      dataIndex: 'enrolment_date',
      render: (text, record) =>
        record["enrolment_date"] !== null && record["enrolment_date"] !== ""
          ? moment(record["enrolment_date"]).format("MM/DD/YYYY")
          : "",
    },
    {
      title: 'Date of DisEnrollment',
      dataIndex: 'dis_enrolment_date',
      render: (text, record) =>
        record["dis_enrolment_date"] !== null && record["dis_enrolment_date"] !== ""
          ? moment(record["dis_enrolment_date"]).format("MM/DD/YYYY")
          : "",
    },    
    {
      title: 'Actions',
      width: '10%',
      render: (text, record) => {        
        let val=moment(record["dis_enrolment_date"]).diff(moment(),'days');
        if( (record["dis_enrolment_date"] !== null && record["dis_enrolment_date"] !== "")&&moment(record["dis_enrolment_date"]).diff(moment(),'days')<=60)
        return (
          <div style={{ display: 'flex' }}>
            <>
              {record.isRequested ? <></> : <i className="fa fa-pencil fa-b" onClick={() => { this.UserDefaultHandler(record) }} />}
            </>
          </div>
        );
      }
    }
    ];
    this.state = {
      addplan: false,
      endata: null
    }
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  UserDefaultHandler = (record) => {
    this.setState({
      addplan: true,
      endata: record
    });
  }
  showConfirm = (type, id) => {
    confirm({
      title: "Do you want to delete this Compliance?",
      onOk: () => this.UserDefaultHandler(type, id),
      okText: "yes",
      cancelText: "No",
      onCancel() { },

    });
  }
  componentDidMount() {
    this.GetEnrollmentsbyUserId();
  }
  GetEnrollmentsbyUserId() {
    this.api.invoke("GetAllEnrolements", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          const enrollments = data.data;

          this.data = enrollments;
          this.setState({ allEnrollmentsLoading: false });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }
  addplanDefaultHandler = (success) => {
    if (success)
      this.GetEnrollmentsbyUserId();
    this.setState({ addplan: !this.state.addplan });
  }
  render() {
    return (
      <Content>
        {(this.state.addplan && this.state.endata) ? <Modal
          visible={this.state.addplan}
        >
          <ManagePlan endata={this.state.endata} userPermandMasters={this.props.userPermandMasters} closeDrawerHandler={this.addplanDefaultHandler} submitHandler={this.UpsertDoc} width="500" /></Modal> : null}
        <div className="mi_main_div">
          <div className="mi_box" style={{ marginLeft: "10px", marginTop: "15px", marginRight: "10px" }}>
            <Row span={24}>
              <Col span={18}>
                <h4 className="mi_box_h4">Manage Plans</h4>
              </Col>
              <Col span={6}>
                <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
              </Col>
            </Row>
          </div>
          <Row span={24} style={{ marginLeft: "8px", marginRight: "10px" }}>
            <Col span={24}>
              <TableWrapper rowKey="id" title="Manage Plans"
                bordered={true} columns={this.columns} data={this.state.allEnrollmentsLoading ? null : this.data} loading={this.state.allEnrollmentsLoading}
                search={true}
              />
            </Col>
          </Row>
        </div>
      </Content>
    );
  }
}
export default Enrollment;
